
import { mapGetters } from 'vuex'
import { pzLoginStorage } from '@/utils'
import { getOS } from '@/utils/sign'
import { getTimeStamp } from '@/utils/sign'

export default {
    name: 'Default',
    data() {
        return {
            messageData: [], // 卡片推送列表
            messageId: 0, // 卡片推送
            timer: null, // 卡片推送定时器
            listState: false, // 处理离线推送给卡片的排序状态
            gameChangeData: {}, // 游戏查询的数据
            searchShow: false, // 游戏查询状态
            tokenTimer: null, // token定时器
            orderIdData: [],
            showReplenishInfo: false
        }
    },
    head() {
        return {
            titleTemplate: this.$config.isPublicProd ? '%s' : '测试',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$config.isPublicProd ? this.$route.meta.title : ''
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            globalShowChat: 'ry/globalShowChat',
            previewList: 'ry/previewList',
            history: 'ry/history',
            customerInfo: 'ry/customerInfo',
            orderFlowShow: 'ry/orderFlowShow',
            userinfo: 'user/userinfo',
            ryToken: 'user/ryToken',
            token: 'user/token',
            hideFooter: 'hideFooter',
            hideHeader: 'hideHeader',
            conversationList: 'ry/conversationList',
            rySendReadReceipt: 'ry/rySendReadReceipt',
            messageReceiptState: 'messageReceiptState',
            imSingleChat: 'ry/imSingleChat',
            bannerColorCode: 'user/bannerColorCode',
            refreshWorkOrder35Progress: 'ry/refreshWorkOrder35Progress'
        }),
        dynamicStyle() {
            return {
                background: `linear-gradient(${this.bannerColorCode} 0%, rgba(255, 210, 202, 0) 100%)`
            }
        }
    },
    watch: {
        $route: {
            handler(route) {
                if (route.name == 'home') {
                    this.gameChangeData = {}
                }
                const initHeadImage = this.userinfo?.headImage === 'https://oss.pzds.com/common/default.png'
                if (route.name !== 'login' && this.token && initHeadImage) {
                    this.showReplenishInfo = true
                }
            }
        },
        messageData(val) {
            if (val.length > 0) {
                this.timer = setTimeout(() => {
                    this.messageData.shift()
                    clearInterval(this.timer)
                    this.timer = null
                }, 60000)
            } else {
                clearInterval(this.timer)
                this.timer = null
            }
            if (val.length > 3) {
                this.messageData.shift()
            }
        },
        userinfo(val) {
            if (!val) {
                this.messageData = []
            } else {
                // this.$store.dispatch('AppGetOssAuth')
            }
        }
    },

    async mounted() {
        if (this.token) {
            // 砍价盒子列表
            this.$store.dispatch('bargaining/getBargainBoxList')
            // 砍价消息未读数量
            this.$store.dispatch('bargaining/getBargainUnReadMessageCount')
        }
        this.$store.commit('SET_MESSAGE_RECEIPT_STATE', true)
        this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
        const hiddenProperty = 'hidden' in document ? 'hidden' : 'webkitHidden' in document ? 'webkitHidden' : 'mozHidden' in document ? 'mozHidden' : null
        const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange')
        document.addEventListener(visibilityChangeEvent, () => {
            // 当可见性改变触发函数
            if (!document[hiddenProperty]) {
                this.$store.commit('SET_MESSAGE_RECEIPT_STATE', true)
            } else {
                this.$store.commit('SET_MESSAGE_RECEIPT_STATE', false)
            }
        })
        // window.localStorage.setItem('userLoggedIn', 'true')
        window.addEventListener('storage', function (event) {
            const status = pzLoginStorage().status
            const key = pzLoginStorage().key
            const loggedInOrOut = [status.loggedIn, status.loggedOut].includes(event.newValue)
            if (event.key === key && loggedInOrOut) {
                // 执行退出登录的逻辑，例如清除用户信息、重定向到登录页面等
                window.location.reload()
            }
        })
        // 渠道管理
        const { pzfrom, bd_vid, qhclickid, uctrackid, keyword, mark_id, sourceid, wbxdId, ad_extras } = this.$nuxt.$route.query
        if (process.client) {
            sessionStorage.pzfrom = pzfrom
            sessionStorage.ad_extras = ad_extras || ''
            if (pzfrom || bd_vid || qhclickid || uctrackid || keyword || mark_id || wbxdId) {
                this.$cookies.set('pzfrom', pzfrom || null, {
                    maxAge: 60 * 60 * 24 * 10000000
                })
                this.$store.commit('SET_PZ_FROM', pzfrom || null)
                const queryString = JSON.stringify(this.$nuxt.$route.query)
                this.$cookies.set('urlParam', queryString || null, {
                    maxAge: 60 * 60 * 24 * 10000000
                })
                this.$store.commit('SET_URL_PARAM', queryString || null)
                // 盼之
                if (pzfrom) {
                    this.$cookies.set('pzfrom', pzfrom || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_PZ_FROM', pzfrom || null)
                    this.$cookies.set('uctrackid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_UCTRACKID', null)
                    this.$cookies.set('qhclickid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_QH_CLICK_ID', null)
                    this.$cookies.set('bd_vid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_DB_VID', null)
                    this.$cookies.set('keyword', keyword || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_SEARCH_WORD', keyword || null)
                    // 微博
                    this.$store.commit('SET_MARK_ID', null)
                    this.$cookies.set('mark_id', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                }
                // 百度渠道
                if (bd_vid) {
                    let vidArr = null
                    let vid = null
                    if (bd_vid.includes(/,|，/g)) {
                        vidArr = bd_vid.split(',')
                        vid = vidArr.length > 1 ? vidArr[1] : vidArr[0]
                    } else {
                        vid = bd_vid
                    }
                    this.$cookies.set('pzfrom', pzfrom || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_PZ_FROM', pzfrom || null)

                    this.$cookies.set('uctrackid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_UCTRACKID', null)

                    this.$cookies.set('qhclickid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_QH_CLICK_ID', null)

                    this.$cookies.set('bd_vid', bd_vid ? vid + 'd' : null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_DB_VID', bd_vid ? vid + 'd' : null)

                    this.$cookies.set('keyword', keyword || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_SEARCH_WORD', keyword || null)
                }
                // 神马渠道
                if (uctrackid) {
                    this.$cookies.set('pzfrom', pzfrom || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_PZ_FROM', pzfrom || null)

                    this.$cookies.set('uctrackid', uctrackid || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_UCTRACKID', uctrackid || null)

                    this.$cookies.set('qhclickid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_QH_CLICK_ID', null)

                    this.$cookies.set('bd_vid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_DB_VID', null)

                    this.$cookies.set('keyword', keyword || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_SEARCH_WORD', keyword || null)
                }
                // 360渠道1
                if (qhclickid) {
                    this.$cookies.set('bd_vid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_DB_VID', null)

                    this.$cookies.set('uctrackid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_UCTRACKID', null)

                    this.$cookies.set('pzfrom', pzfrom || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_PZ_FROM', pzfrom || null)

                    this.$cookies.set('qhclickid', qhclickid || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_QH_CLICK_ID', qhclickid || null)

                    this.$cookies.set('keyword', keyword || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_SEARCH_WORD', keyword || null)
                }
                // 360渠道2
                if (sourceid) {
                    this.$cookies.set('bd_vid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_DB_VID', null)

                    this.$cookies.set('uctrackid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_UCTRACKID', null)

                    this.$cookies.set('qhclickid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_QH_CLICK_ID', null)

                    this.$cookies.set('pzfrom', pzfrom || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_PZ_FROM', pzfrom || null)

                    this.$cookies.set('sourceid', sourceid || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_SOURCE_ID', sourceid || null)

                    this.$cookies.set('keyword', keyword || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_SEARCH_WORD', keyword || null)
                }
                // 微博渠道
                if (mark_id) {
                    this.$cookies.set('bd_vid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_DB_VID', null)

                    this.$cookies.set('uctrackid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_UCTRACKID', null)

                    this.$cookies.set('pzfrom', pzfrom || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_PZ_FROM', pzfrom || null)

                    this.$cookies.set('qhclickid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_QH_CLICK_ID', null)
                    // 微博
                    this.$store.commit('SET_MARK_ID', mark_id)
                    this.$cookies.set('markId', mark_id || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                }
                // 微博小店
                if (wbxdId) {
                    this.$cookies.set('bd_vid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_DB_VID', null)

                    this.$cookies.set('uctrackid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_UCTRACKID', null)

                    this.$cookies.set('pzfrom', pzfrom || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_PZ_FROM', pzfrom || null)

                    this.$cookies.set('qhclickid', null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                    this.$store.commit('SET_QH_CLICK_ID', null)
                    // 微博小店
                    this.$store.commit('SET_WBXD_ID', wbxdId)
                    this.$cookies.set('wbxdId', wbxdId || null, {
                        maxAge: 60 * 60 * 24 * 10000000
                    })
                }
                this.$cookies.set('keyword', keyword || null, {
                    maxAge: 60 * 60 * 24 * 10000000
                })
                this.$store.commit('SET_SEARCH_WORD', keyword || null)
            }
        }
        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ start ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        // 融云初始化，只执行一次
        this.$RongIMLib.init({ appkey: process.env.ENV_RY_KEY })
        // 删除指定会话
        // this.$RongIMLib.removeConversation({
        //     conversationType: 1,
        //     targetId: '2184'
        // })
        // 删除脏数据的指定消息
        // let conversation = {
        //     conversationType: 1,
        //     targetId: ''
        // }
        // this.$RongIMLib
        //     .deleteMessages(conversation, [
        //         {
        //             messageUId: '',
        //             sentTime:'',
        //             messageDirection: 1
        //         }
        //     ])
        //     .then((res) => {
        //         if (res.code === 0) {
        //             console.log('删除成功')
        //         } else {
        //             console.log(res.code, res.msg)
        //         }
        //     })
        // 添加事件监听
        const Events = this.$RongIMLib.Events
        // 离线消息拉取完成再重新拉取会话列表（必须等离线消息拉取完成，才能获取到最新的会话列表）
        this.$RongIMLib.addEventListener(Events.PULL_OFFLINE_MESSAGE_FINISHED, async () => {
            console.warn('离线消息拉取完成')
            // this.$store.dispatch('AppGetOssAuth')
            this.listState = true
            // 初始化会话列表
            await this.$store.dispatch('ry/initConversationList')
            this.$RongIMLib.addEventListener(Events.CONVERSATION, ({ conversationList }) => {
                console.warn('收到会话变更通知------------', conversationList)
                const { conversation } = conversationList[0]
                // 如果收到的会话 latestMessage 字段无值，表示这是一个 系统消息
                this.$store.dispatch('ry/updateConversationList', { ...conversation })
            })
        })
        // 扩展消息
        this.$RongIMLib.addEventListener(Events.EXPANSION, ({ updatedExpansion }) => {
            console.warn('收到扩展消息------------', updatedExpansion)
            this.$store.commit('ry/SET_IM_EXPANSION', updatedExpansion)
        })
        // 链接中断
        this.$RongIMLib.addEventListener(Events.DISCONNECT, code => {
            console.warn('IM=>im链接中断DISCONNECT', code)
            if (code === 31001 || code === 31009) {
                this.$message.error('当前用户暂时封禁聊天功能')
            }
        })
        // 收到新会话
        this.$RongIMLib.addEventListener(Events.MESSAGES, ({ messages }) => {
            console.warn('messages信息*************************', messages)
            messages.map(async (item, index) => {
                if (item.messageType == 'RC:SRSMsg') {
                    // 此类型不做处理
                    messages.splice(index, 1)
                } else if (item.messageType == 'RC:CmdMsg') {
                    if (item.senderUserId === '1') {
                        if (!item?.isOffLineMessage && item?.content?.name == 'bargainNotify') {
                            const data = JSON.parse(item.content.data)
                            const current = await this.getCurrentMsg(data.sessionId)
                            if (current) {
                                this.$store.dispatch('bargaining/updateBargainBoxItem', current)
                            }
                            // 获取砍价消息未读数量
                            this.$store.dispatch('bargaining/getBargainUnReadMessageCount')
                        }
                    }
                    if (item.content.name == 'IM_STATION_NOTIFY') {
                        const ele = {
                            ...JSON.parse(item.content.data),
                            sentTime: item.sentTime,
                            show:true
                        }
                        const timestamp = await getTimeStamp()
                        if (ele.time && timestamp <= ele.time) {
                            this.$store.dispatch('notify/setNotifyList', ele)
                        }
                    }
                    // 工单3.0和3.5
                    if (item.content.name == 'orderNotify') {
                        this.$store.commit('ry/SET_REFRESH_WORKORDER35_PROGRESS', !this.refreshWorkOrder35Progress)
                    }

                    messages.splice(index, 1)
                }
            })

            if (messages.length == 0) {
                return
            }
            // this.$store.dispatch('ry/initConversationList')
            messages.reverse()
            let _tempId = setTimeout(() => {
                this.conversationList.map(itemS => {
                    messages.map((item, index) => {
                        // 处理未打开 当前会话消息不推送卡片
                        if (item.senderUserId == this.userinfo.id) {
                            return
                        }
                        if (item.targetId != this.customerInfo.targetId) {
                            // 修改当前群聊的orderNo
                            if (itemS.targetId == item.targetId && item.messageType == 'panzhi:agencyOrderInfoConfirm') {
                                itemS.orderNo = item.content.content.orderNo
                                this.customerInfo.orderNo = item.content.content.orderNo
                                this.orderIdData.push({
                                    orderNo: item.content.content.orderNo,
                                    targetId: item.targetId
                                })
                            }
                            // 修改当前群聊的名称
                            if (itemS.targetId == item.targetId && item.messageType == 'RC:GrpNtf') {
                                if (item.content.message == '您已被移除群聊' || item.content.message == '群聊已解散') {
                                    return false
                                }
                                itemS.name = item.content.data.groupName
                            }
                            // 群聊信息卡片推送
                            if (itemS.conversationType == 3 && itemS.targetId == item.targetId) {
                                if (item.messageType == 'RC:SRSMsg') {
                                    return
                                }
                                if (item.messageType == 'RC:InfoNtf') {
                                    return
                                }
                                if (index < 3) {
                                    this.messageData.push({
                                        idS: this.messageId++,
                                        img: itemS.portrait,
                                        title: itemS.name,
                                        ...item,
                                        ...itemS
                                    })
                                }
                                // 单聊卡片推送
                            } else if (itemS.conversationType == 1 && itemS.targetId == item.targetId) {
                                if (item.messageType == 'RC:SRSMsg') {
                                    return
                                }
                                if (item.messageType == 'RC:InfoNtf') {
                                    return
                                }
                                // if (item.messageType == 'panzhi:createOrderMsg') return
                                if (index < 3) {
                                    this.messageData.push({
                                        idS: this.messageId++,
                                        ...item,
                                        ...itemS
                                    })
                                }
                            }
                        }
                        // 当前打开对应的会话的数据处理
                        else if (itemS.conversationType == 3 && itemS.targetId == item.targetId) {
                            // 修改群聊名称重新更新会话列表 以及创建中介订单
                            if (item.messageType == 'RC:GrpNtf' || item.messageType == 'panzhi:agencyOrderInfoConfirm') {
                                if (item.messageType == 'panzhi:agencyOrderInfoConfirm') {
                                    itemS.orderNo = item.content.content.orderNo
                                    this.customerInfo.orderNo = item.content.content.orderNo
                                    this.orderIdData.push({
                                        orderNo: item.content.content.orderNo,
                                        targetId: item.targetId
                                    })
                                }
                                if (item.messageType == 'RC:GrpNtf') {
                                    if (item.content.message == '您已被移除群聊' || item.content.message == '群聊已解散') {
                                        return false
                                    }
                                    itemS.name = item.content.data.groupName
                                }
                                const data = {
                                    img: itemS.portrait,
                                    title: itemS.name,
                                    ...item,
                                    ...itemS
                                }
                                this.$refs.imRef.selectConversation(data)
                            }
                        }
                    })
                })
                // 离线消息推送特殊处理数据的排序
                if (this.listState) {
                    this.messageData.reverse()
                    this.listState = false
                }
                clearTimeout(_tempId)
                _tempId = null
            }, 1000)
            // 忽略离线消息，离线消息拉去完成会重新拉取会话列表
            if (messages[0].isOffLineMessage) {
                return false
            }
            if (!this.globalShowChat) {
                const mp3Url = 'https://pzdsoss.pzds.com/common/resources/message-tips.mp3'
                const player = new Audio(mp3Url)
                player.play() // 播放 mp3这个音频对象
            }
            // 会话列表
            // this.$store.dispatch('ry/updateConversationList', [messages[0]])
            // 处理图片合集
            if (messages[0].messageType === 'RC:ImgMsg') {
                const _images = [...this.previewList]
                _images.push(messages[0].content.imageUri)
                this.$store.commit('ry/SET_PREVIEW_LIST', _images) // 用于聊天窗口查看大图;
            }
            // 处理消息的时间显示逻辑
            if (this.history.length > 0) {
                const _lastMsg = this.history[this.history.length - 1]
                const gap = messages[0].sentTime - _lastMsg.sentTime
                if (gap < 300000) {
                    messages[0].hiddenTime = true
                }
            }
            // // 更新历史记录
            for (let index = 0; index < messages.length; index++) {
                if (this.customerInfo.targetId == messages[index].targetId) {
                    if (this.globalShowChat == true) {
                        // 单聊消息回执
                        if (this.customerInfo.conversationType == '1' && this.customerInfo.latestMessage != null && this.messageReceiptState) {
                            if (messages[index].content.user.id != this.userinfo.id) {
                                this.$RongIMLib
                                    .sendReadReceiptMessage(messages[index].targetId, messages[index].messageUId, messages[index].sentTime)
                                    .then(res => {
                                        if (res.code === 0) {
                                            this.$store.dispatch('ry/clearUnreadCount')
                                        }
                                    })
                                    .catch(error => {
                                        console.warn(error)
                                    })
                            }
                        }
                        if (this.customerInfo.conversationType == '3' && this.customerInfo.latestMessage != null && this.messageReceiptState) {
                            this.$store.dispatch('ry/clearUnreadCountCopy')
                        }
                    }

                    // 撤回消息
                    if (messages[index].messageType == 'RC:RcCmd') {
                        const newMessageList = [...this.history].map(item => {
                            if (item.messageUId == messages[index].content.messageUId) {
                                return (item = {
                                    ...messages[index],
                                    messageType: 'RC:RcCmd'
                                })
                            } else {
                                return item
                            }
                        })

                        this.$store.commit('ry/SET_IS_NEW_MESSAGE', true)
                        this.$store.commit('ry/SET_HISTORY', [...newMessageList])
                    } else {
                        messages.reverse()
                        // if (messages[index].conversationType == 1 && messages[index].content.user.id == this.userinfo.id) {
                        //     messages[index].lockState = 2
                        // }
                        this.$store.commit('ry/SET_IS_NEW_MESSAGE', true)
                        this.$store.commit('ry/SET_HISTORY', [...this.history, { ...messages[index] }])
                        messages.reverse()
                    }
                }
            }
            // 群的@ 消息更新
            if (
                messages[0].conversationType == 3 &&
                messages[0].content?.mentionedInfo &&
                ((messages[0].content?.mentionedInfo?.type === 2 && messages[0].content?.mentionedInfo?.userIdList?.includes(this.userinfo.id.toString())) ||
                    (messages[0].content?.mentionedInfo?.type === 1 && messages[0].content?.user?.id !== this.userinfo.id.toString()))
            ) {
                messages[0].receivedStatus = 0
                this.$store.dispatch('ry/updateGroupMentionedInfo', [messages[0]])
            }
        })
        // 刷新页面后重连
        if (this.userinfo?.id) {
            if (this.ryToken) {
                this.$store.dispatch('ry/initConnect', this.ryToken)
            } else {
                this.$api.getImInfo().then(({ success, data }) => {
                    if (success) {
                        this.$store.dispatch('ry/initConnect', data)
                    }
                })
            }
        }
        // 每隔 28 分钟去刷新一次token
        // this.tokenTimer = setInterval(() => {
        //     this.$store.dispatch('AppGetOssAuth')
        // }, 1680000)
        // 储存系统信息
        this.$store.commit('SET_OPERATING_SYSTEM', getOS())

        // 监听发送消息回执{ conversation, messageUId, senderUserId }
        this.$RongIMLib.addEventListener(Events.MESSAGE_RECEIPT_REQUEST, ({ conversation, messageUId, senderUserId }) => {
            if (this.rySendReadReceipt.length == 0) {
                this.rySendReadReceipt.push({
                    ...conversation,
                    senderUserId,
                    messageUId: [messageUId]
                })
            } else {
                const arr = JSON.stringify(this.rySendReadReceipt)
                if (arr.includes(conversation.targetId) && arr.includes(senderUserId)) {
                    this.rySendReadReceipt.map(item => {
                        if (item.targetId == conversation.targetId && item.senderUserId == senderUserId) {
                            item.messageUId.push(messageUId)
                        }
                    })
                } else {
                    this.rySendReadReceipt.push({
                        ...conversation,
                        senderUserId,
                        messageUId: [messageUId]
                    })
                }
            }
            this.$store.commit('ry/SET_RY_SEND_READ', this.rySendReadReceipt)

            if (
                conversation.targetId == this.customerInfo.targetId &&
                this.customerInfo.conversationType == '3' &&
                this.customerInfo.latestMessage != null &&
                this.messageReceiptState &&
                this.userinfo.id != senderUserId
            ) {
                const messageList = {}
                messageList[senderUserId] = [messageUId]
                this.$RongIMLib.sendReadReceiptResponseV2(this.customerInfo.targetId, messageList).then(res => {
                    if (res.code === 0) {
                        console.warn(res.code, res, '群聊已读成功~~~~~~~~~~~~~~')
                        this.rySendReadReceipt.map((item, index) => {
                            if (item.targetId == this.customerInfo.targetId) {
                                this.rySendReadReceipt.splice(index, 1)
                            }
                        })
                        this.$store.commit('ry/SET_RY_SEND_READ', this.rySendReadReceipt)
                        // 清除未读数
                        this.$store.dispatch('ry/clearUnreadCount')
                    } else {
                        console.warn(res.code, res.msg, '群聊已读失败~~~~~~~~~~~~~~')
                    }
                })
            }
        })
        // 监听单聊回执接收消息回执 {conversation, messageUId, sentTime, sendUserId}
        this.$RongIMLib.addEventListener(Events.READ_RECEIPT_RECEIVED, data => {
            console.warn(data, '监听单聊接收消息回执')
            if (!this.messageReceiptState) {
                return
            }
            if (data.sendUserId == this.userinfo.id) {
                return
            }
            const arr = JSON.stringify(this.imSingleChat)
            if (arr.includes(data.conversation.targetId)) {
                this.imSingleChat.map(item => {
                    if (item.targetId == this.customerInfo.targetId) {
                        item.messageUId = data.messageUId
                        item.sendUserId = data.sendUserId
                        // item.startTime = data.sentTime
                        item.endTime = data.sentTime
                    }
                })
            } else {
                this.imSingleChat.push({
                    targetId: data.conversation.targetId,
                    messageUId: data.messageUId,
                    sendUserId: data.sendUserId,
                    startTime: data.sentTime,
                    endTime: null
                })
            }
            this.$store.commit('ry/SET_IM_SINGLECHAT', this.imSingleChat)
        })
        // 监听群聊接收消息回执{ conversation, receivedUserId, messageUIdList }
        this.$RongIMLib.addEventListener(Events.MESSAGE_RECEIPT_RESPONSE, ({ conversation, receivedUserId, messageUIdList }) => {
            this.history.map(item => {
                messageUIdList.map(items => {
                    if (item.messageUId == items) {
                        if (!item.readReceiptInfo?.readerList) {
                            return
                        }
                        if (item.readReceiptInfo?.readerList.length == 0) {
                            item.readReceiptInfo.readerList.push(receivedUserId)
                        } else {
                            item.readReceiptInfo.readerList.map((idItem, idIndex) => {
                                if (idItem == receivedUserId) {
                                    item.readReceiptInfo.readerList.splice(idIndex, 1)
                                } else {
                                    item.readReceiptInfo.readerList.push(receivedUserId)
                                }
                            })
                        }
                    }
                })
            })
            this.$store.commit('ry/SET_HISTORY', this.history)
            this.$refs.imRef.forceUpdateHistory()
        })
        // 获取服务器时间
        this.$store.dispatch('GetSeverTime')
        // 监听页面刷新或者关闭清除砍价成功ID
        window.addEventListener('beforeunload', () => {
            this.$store.commit('user/SET_BARGAIN_TIP_ID', '')
        })
    },
    beforeUnmount() {
        this.stopTimer()
        // 🛡️ 清理防抖定时器，防止内存泄漏
        this.$store.dispatch('bargaining/clearBargainDebounceTimer')
    },
    methods: {
        /**
         * 获取当前会话的最新消息
         * @param {string} sessionId - 会话ID
         * @returns {object|null} - 当前会话的最新消息对象，或null如果未找到
         */
        async getCurrentMsg(sessionId) {
            const { data = [] } = await this.$api.messageBoxListAPI({
                action: {
                    bargainOrderNo: '',
                    offsetId: 0,
                    searchType: 0,
                    sessionIds: [],
                    up: true
                }
            })
            let current = null
            if (data.length > 0) {
                current = data.find(item => item.sessionId == sessionId)
            }
            return current
        },
        // 打开消息推送的聊天关闭卡片
        deleteIndex(item, index, state) {
            if (state == '1') {
                this.orderIdData.map(itemS => {
                    if (item.targetId == itemS.targetId) {
                        item.orderNo = itemS.orderNo
                    }
                })
                this.$nextTick(() => {
                    this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
                    this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)
                    this.$refs.imRef.selectConversation(item)
                    this.messageData.splice(index, 1)
                })
            } else {
                this.messageData.splice(index, 1)
            }
        },
        // 显示游戏查询
        clickShow() {
            this.searchShow = !this.searchShow
        },
        // 清空定时器
        stopTimer() {
            if (this.tokenTimer) {
                clearInterval(this.tokenTimer)
                this.tokenTimer = null
            }
        },
        // 打开会话时清空当前会话的卡片推送
        closeTag(val) {
            if (this.messageData.length > 0) {
                this.messageData = this.messageData.filter(item => item.targetId != val.targetId)
            }
        }
    }
}
